import { Suspense } from "react";
import { Box, Card, CardContent, CardActionArea, Chip } from '@mui/material'

import { html, newlines } from '@/utils/Format';
import { date } from "@/utils/Dates";

import Button from '@/components/Button';

import { 
    ArrowBack as BackIcon,
    RemoveRedEye as ViewIcon
} from '@mui/icons-material';

export default function Item({t,table,columns,item,back,handleBack,viewPath,openUrlModal}){

    // to go back to items list
    const handleButtonBack = () => {
        handleBack();
    }

    return (    
        <div className="w-full">  
            {/*
                back &&
                <div className="flex justify-center items-center mx-1 mb-4">
                    <div className="">
                        <Button
                            onClick={handleButtonBack}
                            text={t('actions.back.button')}
                            type='back'
                            startIcon={<BackIcon/>}
                        />
                    </div>
                </div>
            */}
            {
                viewPath === 'fullview' &&
                <div className='text-center font-bold capitalize text-2xl'>
                    {t(table+'.menu.title')}
                </div>
            }            
            {
                item && Object.keys(item)?.length > 0 ?
                    
                    <div className='mt-4 rounded px-8 pt-8 pb-2 bg-gray-50 border border-gray-200'>
                        {
                            columns && Object.keys(columns)?.map((field) => {

                                // what to print if no value
                                const emptyValue = '-';

                                var config = columns[field];
                                var type = config?.type;                        
                                var render = null;
                                let fieldValue;
                                let values;
                                let value;

                                switch(type){
                                    
                                    case 'id':
                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                {item && Object.hasOwn(item,field) ? item[field] : emptyValue}
                                            </Suspense>
                                        ;                             
                                        break;                                

                                    case 'html':
                                        render = 
                                                <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                    {
                                                        item && Object.hasOwn(item,field) && item[field] && item[field]?.length > 0 ?
                                                            <div dangerouslySetInnerHTML={{__html: html(item[field])}}></div>
                                                        :
                                                            ''
                                                    }
                                                </Suspense>
                                            ;
                                        break;

                                    case 'boolean':
                                    case 'boolean_badge':
                                    case 'boolean_checkbox':

                                        fieldValue = false;
                                        if(item && Object.hasOwn(item,field) && item[field] !== null){
                                            fieldValue = item[field];
                                        }

                                        var names = [t('types.boolean.no'),t('types.boolean.yes')];
                                        if(config && Object.hasOwn(config,'values')){                                                
                                            names = [t(table+'.'+field+'.'+config.values[0]),t(table+'.'+field+'.'+config.values[1])];
                                        }

                                        var fieldString = fieldValue ? names[1] : names[0];
                                
                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                <div className=''>
                                                    {fieldString}
                                                </div>
                                            </Suspense>                                        
                                        ;
                                        break;

                                    case 'datetime':
                                    case 'datetime_offset':
                                    case 'date':
                                    case 'hour':                                            
                                        fieldValue = emptyValue;
                                        if(item && Object.hasOwn(item,field)){

                                            if(type === 'datetime' || type === 'datetime_offset'){
                                                fieldValue = date(item[field],true,true);
                                            }
                                            else{
                                                fieldValue = date(item[field]);
                                            }

                                            if(!fieldValue){
                                                fieldValue = emptyValue;
                                            }
                                        }

                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                <div className=''>
                                                    {fieldValue}
                                                </div>
                                            </Suspense>
                                        ;
                                        break;                                

                                    case 'int':
                                    case 'float':
                                    case 'price':
                                    case 'percentage':
                                        render = 
                                                <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                    <div className=''>
                                                        {item && Object.hasOwn(item,field) ? item[field] ? item[field] : emptyValue : emptyValue}
                                                    </div>
                                                </Suspense>
                                            ;
                                        break;

                                    case 'dropdown':
                                    case 'dropdown_search':

                                        values = config?.values;
                                        if(!values || values.length === 0){
                                            values = [];
                                        }

                                        value = '';
                                        if(item && Object.hasOwn(item,field) && item[field] !== null){

                                            // if invalid option
                                            value = 'ID: '+item[field]+' ('+t('error.notvalid')+')';

                                            values.map((val) => {
                                                if(val?.id === item[field]){
                                                    
                                                    value = val?.name;

                                                    // if needs translation
                                                    if(config?.translate){
                                                        value = val?.name && val.name.length > 0 ? t(table+'.'+field+'.'+value) === table+'.'+field+'.'+value ? value : t(table+'.'+field+'.'+value) : '';
                                                    }

                                                    return;
                                                }
                                            });
                                        }

                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                <div className=''>
                                                    {value ? value : emptyValue}
                                                </div>
                                            </Suspense>
                                        ;
                                        break;

                                    case 'dropdown_multiple':  

                                        values = config?.values;
                                        if(!values || values.length === 0){
                                            values = [];
                                        }

                                        value = [];
                                        if(item && Object.hasOwn(item,field) && item[field] !== null && item[field].length > 0){

                                            var ids = [];
                                            item[field].map((val) => {
                                                ids.push(val?.id);
                                            });                                            

                                            var alreadyChecked = [];
                                            values.map((val) => {
                                                if(ids.includes(val?.id) && !alreadyChecked.includes(val?.id)){
                                                    
                                                    var itemName = val?.name;

                                                    // if needs translation
                                                    if(config?.translate){         
                                                        itemName = itemName && itemName.length > 0 ? t(table+'.'+field+'.'+itemName) === table+'.'+field+'.'+itemName ? itemName : t(table+'.'+field+'.'+itemName) : '';
                                                    }

                                                    value.push(itemName);
                                                    
                                                    alreadyChecked.push(val?.id);
                                                    
                                                    return;
                                                }
                                            });
                                        }

                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                <div className=''>
                                                    {
                                                        value && value?.length > 0 ?
                                                            value.map((val) => (
                                                                <>{val}<br/></>
                                                            ))
                                                        :
                                                            emptyValue
                                                    }
                                                </div>
                                            </Suspense>
                                        ;
                                        break;

                                    case 'file':
                                        
                                        if(item && Object.hasOwn(item,field) && item[field] !== null && item[field].length > 0){

                                            var files = item[field];

                                            render =                                                 
                                                <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                    <div className='item-modal-link-files'>
                                                        {
                                                            files?.map((file,index) => {

                                                                var linkText = file?.name ? file.name : file?.type && t('types.'+file.type) !== 'types.'+file.type ? t('types.'+file.type) : t('types.file');                                                                
                                                                
                                                                return (                                                                        
                                                                    <div className={file.type === 'image' ? 'item-modal-link-file-preview-div' : 'item-modal-link-file-div'}>
                                                                        <div className='truncate'>{linkText}</div>                                                                              
                                                                        <div className=''>
                                                                            {
                                                                                (!config?.target || config.target === 'modal') && openUrlModal ?
                                                                                    <a 
                                                                                        key={'table_'+table+'_item_'+file?.rowIndex+'_field_'+field+'_file_'+index} 
                                                                                        className={`${file.type === 'image' ? 'item-modal-link-image cursor-pointer' : 'item-modal-link-file cursor-pointer'}`} 
                                                                                        onClick={() => openUrlModal(file?.path)}
                                                                                    >                                                                                        
                                                                                        {
                                                                                            file.type === 'image' ? 
                                                                                                <img className='item-modal-image' src={file?.path}/>
                                                                                            :
                                                                                                file.type === 'pdf' ?
                                                                                                    <div className='item-modal-file'>
                                                                                                        <iframe
                                                                                                            src={file?.path}                    
                                                                                                            style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                                                                        ></iframe>
                                                                                                    </div>
                                                                                                :
                                                                                                    <div className='item-modal-file'><ViewIcon fontSize='large'/></div>
                                                                                        }                                                                                        
                                                                                    </a>
                                                                                :
                                                                                    <a 
                                                                                        key={'table_'+table+'_item_'+file?.rowIndex+'_field_'+field+'_file_'+index} 
                                                                                        className={`${file.type === 'image' ? 'item-modal-link-image' : 'item-modal-link-file'}`} 
                                                                                        href={file?.path} target={config?.target}
                                                                                    >                                                                                
                                                                                        {
                                                                                            file.type === 'image' ?
                                                                                                <img className='item-modal-image' src={file?.path}/>
                                                                                            :
                                                                                                file.type === 'pdf' ?
                                                                                                    <div className='item-modal-file'>
                                                                                                        <iframe
                                                                                                            src={file?.path}                    
                                                                                                            style={{width:'100%', height: '100%', pointerEvents: 'none'}}
                                                                                                        ></iframe>
                                                                                                    </div>
                                                                                                :
                                                                                                    <div className='item-modal-file'><ViewIcon fontSize='large'/></div>
                                                                                        }
                                                                                        
                                                                                    </a>
                                                                            }
                                                                        </div>                                                                        
                                                                    </div> 
                                                                );
                                                            })
                                                        }
                                                    </div>
                                                </Suspense>                                                
                                            ;                                            
                                        }
                                        break;
                                    
                                    default:

                                        // text, textlong                                    
                                        render = 
                                            <Suspense key={'table_'+table+'_item_'+item?.id+'_field_'+field}>
                                                <div className=''>
                                                    {
                                                        item && Object.hasOwn(item,field) && item[field] && item[field]?.length > 0 ?

                                                            (type === 'link' || type === 'linkshort' || type === 'email' || type === 'phone') ?

                                                                (!config?.target || config.target === 'modal') && openUrlModal ?
                                                                    <a className='item-modal-link cursor-pointer' onClick={() => openUrlModal(item[field])}>
                                                                        {
                                                                            type === 'linkshort' ?
                                                                                t('types.link')
                                                                            :
                                                                                type === 'link' && config && Object.hasOwn(config,'value') ?
                                                                                    t(table+'.'+field+'.'+config.value)
                                                                                :
                                                                                    item[field]
                                                                        }
                                                                    </a>
                                                                :
                                                                    <a 
                                                                        className='item-modal-link' 
                                                                        href={`${type === 'email' ? 'mailto:' : type === 'phone' ? 'tel:' : '' }${item[field]}`} 
                                                                        target={type === 'email' || type === 'phone' ? '_blank' : config?.target }>
                                                                        {
                                                                            type === 'linkshort' ?
                                                                                t('types.link')
                                                                            :
                                                                                type === 'link' && config && Object.hasOwn(config,'value') ?
                                                                                    t(table+'.'+field+'.'+config.value)
                                                                                :
                                                                                    item[field]
                                                                        }
                                                                    </a>
                                                            :
                                                                type === 'textlong' ?
                                                                    <div dangerouslySetInnerHTML={{__html: newlines(item[field])}}></div>
                                                                :
                                                                    config?.values && Object.hasOwn(config.values,item[field]) ? 
                                                                        t(table+'.'+field+'.'+config.values[item[field]]) 
                                                                    : 
                                                                        item[field]
                                                        :
                                                            emptyValue
                                                    }
                                                </div>
                                            </Suspense>
                                        ;
                                        break;
                                }                        

                                return (
                                    <div 
                                        key={'table_'+table+'_item_'+item?.id+'_field_'+field+'_div'}
                                        className='mb-6'
                                    >
                                        <div className='item-modal-title'>
                                            {t(table+'.fields.'+field)}
                                        </div>                        
                                        {render}
                                    </div>
                                );
                            })
                        }
                    </div>
                :
                    <div className='mt-4 mb-8 text-center'>
                        {t('error.dataretrievingerror')}
                    </div>
            }            
            {
                back &&
                <div className="flex justify-center items-center mx-1 mt-4">
                    <div className="">
                        <Button
                            onClick={handleButtonBack}
                            text={t('actions.back.button')}
                            type='back'
                            startIcon={<BackIcon/>}
                        />
                    </div>
                </div>
            }
        </div>
    );
}